import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '../../molecules/ButtonGroup';
import './Poll.css'

const availabilityOptions = [
  {
    label: "Available",
    value: "available",
  },
  {
    label: "Unavailable",
    value: "unavailable",
  },
  {
    label: "Maybe",
    value: "maybe",
  },
];

// TODO - Make some common utility methods for common rendering between polls
class Poll extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      userResponses: {},
    };
  }

  componentWillMount() {
    this.setState({
      userResponses: this.getUserResponses(this.props),
    });
  }

  componentWillReceiveProps(nextProps) {
    if ( nextProps.responses !== this.props.responses ) {
      this.setState({
        userResponses: this.getUserResponses(nextProps),
      });
    }
  }

  getUserResponses({userId, responses}) {
    let resps = {};
    if ( responses[userId] ) {
      resps = {
        ...responses[userId],
      };
    }
    return resps;
  }

  respond = (id, response) => {
    this.props.respond({
      pollId: this.props.id,
      choiceId: id,
      userId: this.props.userId,
      response,
    });
  }

  getResponsesByChoice = (response, choiceId, allResponses = {}) => {
    // get responses including this users current response
    const responses = Object.keys(allResponses).filter(personId => {
      return personId !== this.props.userId;
    }).map(personId => {
      return {
        response: allResponses[personId][choiceId],
      };
    }).concat([
      {
        response,
      }
    ]);

    // return filtered lists
    return {
      available: responses.filter(r => r.response === "available"),
      unavailable: responses.filter(r => r.response === "unavailable"),
      maybe: responses.filter(r => r.response === "maybe"),
    };
  }

  wrap = (className, intro, footer) => {
    const {options, responses} = this.props;
    return (
      <div className={"Poll" + (className ? ` ${className}` : "")}>

        {intro}

        <div className="Choice sample">
          <div className="Choice-Header">
            <span className="Choice-Range"> &nbsp; </span>
            <span className="Choice-Responses">
              <span className="available">Y</span>
              <span className="unavailable">N</span>
              <span className="maybe">?</span>
            </span>
          </div>
        </div>

        {Object.keys(options).map(optionId => {

          const choice = options[optionId];
          const respond = (r) => {
            this.respond(optionId, r);
          };
          const setNoResponse = () => {
            respond(undefined);
          };

          const chosenResponse = this.state.userResponses[optionId];
          const hasResponse = typeof chosenResponse !== "undefined";
          const showResponseOptions = !hasResponse;
          const resps = this.getResponsesByChoice(chosenResponse, optionId, responses);

          return (
            <div key={optionId} className={"Choice" + (hasResponse ? " responded" : "")}>
              <div className="Choice-Header">
                <span className="Choice-Range" onClick={setNoResponse}>
                  {this.renderChoiceHeader(choice)}
                </span>
                <span className="Choice-Responses">
                  <span className={"available" + (chosenResponse==="available" ? " chosen" : "")}>{resps.available.length}</span>
                  <span className={"unavailable" + (chosenResponse==="unavailable" ? " chosen" : "")}>{resps.unavailable.length}</span>
                  <span className={"maybe" + (chosenResponse==="maybe" ? " chosen" : "")}>{resps.maybe.length}</span>
                </span>
              </div>
              {showResponseOptions && (
                <div className="Choice-Response-Options">
                  <ButtonGroup
                    options={availabilityOptions}
                    onChange={respond}
                    value={chosenResponse}
                  />
                </div>
              )}
            </div>
          );
        })}

        {footer}

      </div>
    );
  }

  renderChoiceHeader() {
    throw new Error("Implement Me");
  }

  render() {
    return this.wrap("Poll");
  }

}

Poll.defaultProps = {
  options: {},
  type: 'dates',
}

Poll.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["dates"]).isRequired,
  options: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  responses: PropTypes.object.isRequired,
  respond: PropTypes.func,
};

export default Poll;



// WEBPACK FOOTER //
// ./src/component/molecules/Poll/component.js